import { getLocalStorage, removeLocalStorage, setLocalStorage } from "@/utils/storage";
const SMS_CONSENT_STORAGE_KEY = "sms_consent";
export function setAlreadyAskedForSMSConsent() {
    setLocalStorage(SMS_CONSENT_STORAGE_KEY, true);
}
export function getAlreadyAskedForSMSConsent() {
    return getLocalStorage(SMS_CONSENT_STORAGE_KEY) ?? false;
}
export function removeAlreadyAskedForSMSConsent() {
    removeLocalStorage(SMS_CONSENT_STORAGE_KEY);
}
